import React from "react";
import Service from '../service/Service';
import * as actions from './Actions';

export default function ShareOptions({ feedItem, eleRef }) {
    return (

        <div className="sharing-options">
        {feedItem.type=="articles" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', feedItem.data[0].articleUrl)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', feedItem.data[0].articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', feedItem.data[0].articleUrl)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', feedItem.data[0].articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', feedItem.data[0].articleUrl)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', feedItem.data[0].articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', feedItem.data[0].articleUrl)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // prevent scrolling when pressing Space
                    actions.shareVideo('whatsapp', feedItem.data[0].articleUrl);
                  }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        
        }

        {feedItem.type=="multiplearticles" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        
        }

        {feedItem.type=="quiz" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.redirectUrl)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', eleRef.redirectUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg gtm-quiz-fb" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.redirectUrl)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', eleRef.redirectUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg gtm-quiz-twitter" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.redirectUrl)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', eleRef.redirectUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg gtm-quiz-pntrest" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.redirectUrl)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', eleRef.redirectUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg gtm-quiz-whtapp" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        
        }


        {feedItem.type=="video" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', feedItem.data[0].url)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', feedItem.data[0].url);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg gtm-video-fb" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', feedItem.data[0].url)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', feedItem.data[0].url);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg gtm-video-twitter" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', feedItem.data[0].url)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', feedItem.data[0].url);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg gtm-video-pintrest" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', feedItem.data[0].url)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', feedItem.data[0].url);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg gtm-video-whatsapp" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        }

         {feedItem.type=="memoriesview" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        }
	
{feedItem.type=="dietplanmom" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        }
	 {feedItem.type=="writeforus" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.articleUrl)} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', eleRef.articleUrl);
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        }


        {feedItem.type=="weekbyweekfataldevelopement" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        }

        {feedItem.type=="Babysizecomparison" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', 'https://parenting.firstcry.com/tools/baby-size-comparison/')} role="button" tabIndex={0} aria-label="Share on Facebook" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('facebook', 'https://parenting.firstcry.com/tools/baby-size-comparison/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg gtm-babysize-fb" alt="facebook" title="Share on Facebook"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', 'https://parenting.firstcry.com/tools/baby-size-comparison/')} role="button" tabIndex={0} aria-label="Share on Twitter" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('twitter', 'https://parenting.firstcry.com/tools/baby-size-comparison/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg gtm-babysize-twitter" alt="twitter" title="Share on Twitter"/>
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', 'https://parenting.firstcry.com/tools/baby-size-comparison/')} role="button" tabIndex={0} aria-label="Share on Pinterest" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('pintrest', 'https://parenting.firstcry.com/tools/baby-size-comparison/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg gtm-babysize-pntrest" alt="pinterest" title="Share on Pinterest"/>
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/tools/baby-size-comparison/')} role="button" tabIndex={0} aria-label="Share on WhatsApp" onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault(); // prevent scrolling when pressing Space
                        actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/tools/baby-size-comparison/');
                    }
                }}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg gtm-babysize-whsapp" alt="whatsapp" title="Share on WhatsApp"/>
                    </div>
                </li>
            </ul>
        }




        



        
        </div>

    );
}
